let baseUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    // baseUrl = '//10.0.0.128:9911'
    baseUrl = '//javaapi.shshengmu.cn' // 生产环境url
    break
  case 'production':
    baseUrl = '//javaapi.shshengmu.cn' // 生产环境url
    break
}
export default baseUrl;
